<template>
  <div class="webview flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col xs="12">
          <div class="clearfix">
            <h1 class="web-hidden">1on1naviヘルプ</h1>
            <div role="tablist">
              <b-card v-for="(help, idx) in helps" v-bind:key="'help'+idx" no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-btn block href="#" v-b-toggle="'help' + idx" variant="info">{{ help.head }}</b-btn>
                </b-card-header>
                <b-collapse :id="'help' + idx" accordion="helpAccordion" role="tabpanel">
                  <b-card-body>
                    <p class="card-text" v-html="help.body"></p>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<style scoped>
.webview {
  overflow: auto;
}
h1 {
  text-align: center;
  font-size: 1.7rem;
}
h2 {
  font-size: 1.25rem;
}
h3 {
  font-size: 1.15rem;
}
h2 > span {
  margin-left: 1em;
  text-decoration: underline;
}
span.nth {
  margin-right: 0.5em;
}
.card-header .btn {
  white-space: normal;
  text-align: left;
}
</style>

<script>
// import { content1on1 } from '@/main'
export default {
  name: 'WebViewHelpsJARe',
  data () {
    return {
      oneContentSet: this.get1on1Contents,
      helps: [
        {
          head: `1on1naviの基本メニュー`,
          body: `
トップ画面の左側に以下のメニューが配置されています。<ul class="list-adjusted">
<li>・${this.$t('topTitle')}</li>
<li>・${this.$t('oneOnTitleType')}</li>
<li>・${this.$t('rtfbType')}</li>
<li>・People</li>
<li>・Notice</li>
<li>・Report</li>
<li>・Other</li>
</ul>`
        },
        {
          head: `ユーザーを検索する`,
          body: `
基本メニューからPeopleをクリックして、サブメニューからPeopleを選択すると、検索欄と最近チェックしたユーザーのリストが表示されます。<br><br>
検索欄に氏名を入力すると検索結果が表示されます。<br>
該当するユーザーの氏名をクリックすると、情報が表示されます。<br>
`
        },
        {
          head: `グループを作成する`,
          body: `
グループを作成することで、${this.$t('topTitle')}、${this.$t('oneOnTitleType')}、${this.$t('rtfbType')}の公開範囲をグループに登録されているユーザーに設定することやグループメンバーの通知を受け取る設定を一括で行うことができます。<br><br>
基本メニューのPeopleをクリックして、グループ作成を選択します。グループ名を入力した後、「＋メンバー追加」ボタンをクリックして、ユーザーを検索して追加するユーザーが表示されたら選択します（チェックがつきます）。※グループタブから既に作成しているグループメンバーを一括で候補選択することもできます。<br>
「保存」を押すとグループが作成されます。<br>
作成したグループはメニューのグループ一覧からも確認できます。<br>
`
        },
        {
          head: `${this.$t('topTitle')}を確認する`,
          body: `
基本メニューにある${this.$t('topTitle')}をクリックして、サブメニューから${this.$t('topTitle')}一覧を選択すると、${this.$t('topTitle')}の一覧が表示されます。<br><br>

${this.$t('okrDetailType')}について、進捗率、内容、開始日、期限、コメント数、${this.$t('relatedOkrType')}数が表示され、
その下に${this.$t('okrDetailType')}に紐づく${this.$t('keyResultDetailType')}の情報が表示されます。<br>
※コメント数、${this.$t('relatedOkrType')}数の数字がオレンジで太字の場合は未読のコメント、${this.$t('relatedOkrType')}があります。<br><br>

${this.$t('topTitle')}の一覧より、詳細を確認したい${this.$t('okrDetailType')}または${this.$t('keyResultDetailType')}を選択すると画面右に以下の詳細項目が表示されます。<br><br>
<ul class="list-adjusted">
<li>・作成日（日時）</li>
<li>・目標 ※文字数が多い場合はハイライト表示されますが、「もっと見る」をクリックすることで内容が確認できます。</li>
<li>・開始日</li>
<li>・期限</li>
<li>・公開</li>
<li>・進捗率</li>
<li>・コメント</li>
<li>・${this.$t('relatedOkrType')} ※${this.$t('relatedOkrType')}は他のユーザーが関連付けた${this.$t('topTitle')}も表示されます。</li>
</ul>`
        },
        {
          head: `${this.$t('topTitle')}を登録する（${this.$t('okrDetailType')}、${this.$t('keyResultDetailType')}を登録する）`,
          body: `
基本メニューの${this.$t('topTitle')}をクリックして、サブメニューから${this.$t('okrDetailType')}登録を選択します。<br><br>

${this.$t('okrDetailType')}登録画面より、以下の項目を入力・選択します。<br>
<ul class="list-adjusted">
<li>・「目標」：${this.$t('okrDetailType')}の内容を、文字入力によって登録します。</li>
<li>・「開始日」、「期限」：クリックすると「カレンダー」から設定することが可能です。特に指定がない場合は、「操作日」となります。</li>
<li>・「進捗率」：円形のゲージをドラックすることで設定できます。円形のゲージ内の数値を直接入力することも可能です。</li>
<li>・「公開設定」：右にある「＋追加」ボタンをクリックしてユーザー、グループまたは組織を設定することが可能です。特に指定がない場合は、公開範囲は「全員」となります。</li>
<li>・「${this.$t('relatedOkrType')}」：右にある「＋追加」ボタンをクリックして、ユーザーを検索・選択して、そのユーザーの${this.$t('topTitle')}一覧を表示し、${this.$t('okrDetailType')}または${this.$t('keyResultDetailType')}をクリックして、${this.$t('relatedOkrType')}として設定することができます。</li>
</ul><br>

「保存」または「下書きとして保存」をクリックすることで、登録または下書き保存が完了します。<br>
${this.$t('okrDetailType')}の登録が完了すると、${this.$t('topTitle')}一覧に追加されます。${this.$t('topTitle')}一覧の${this.$t('okrDetailType')}の一番下にある「＋${this.$t('keyResultDetailType')}を追加」ボタンをクリックすることで${this.$t('keyResultDetailType')}が登録できます。<br>
${this.$t('keyResultDetailType')}の登録内容項目は${this.$t('okrDetailType')}と同じです。<br>
`
        },
        {
          head: `${this.$t('relatedOkrType')}として${this.$t('okrDetailType')}（${this.$t('keyResultDetailType')}）を関連付ける`,
          body: `
基本メニューの「${this.$t('topTitle')}」の中の「${this.$t('topTitle')}一覧」をクリックすると、「${this.$t('topTitle')}一覧」画面が表示されます。<br><br>

関連付けしたい${this.$t('okrDetailType')}（${this.$t('keyResultDetailType')}）をクリックすると、画面右側にクリックした${this.$t('okrDetailType')}（${this.$t('keyResultDetailType')}）が表示されます。<br><br>

（「コメント」の右側にある）「${this.$t('relatedOkrType')}」をクリックすると、「＋${this.$t('relatedOkrType')}を追加」ボタンが表示されます。<br><br>

「＋${this.$t('relatedOkrType')}を追加」ボタンをクリックし、「ユーザ名で検索」欄にて関連付けしたい${this.$t('topTitle')}を設定しているユーザを検索します。<br>
また、以前にチェックしたユーザーがいる場合はリスト表示がされます。<br><br>

関連付けしたい${this.$t('topTitle')}を設定しているユーザが表示されるので、クリックをしてそのユーザの${this.$t('topTitle')}一覧を表示します。<br><br>

関連付けしたい${this.$t('topTitle')}をクリックすると、「追加 ${this.$t('relatedOkrType')}を追加しますか？」ウィンドウが表示されるので「OK」をクリックすると、「保存しました」ウィンドウが表示され、関連付けがされます。<br><br>

画面右側の「${this.$t('relatedOkrType')}」欄にて関連付けされている${this.$t('topTitle')}を確認することができます。<br><br>
`
        },
        {
          head: `${this.$t('topTitle')}の進捗率を変更する`,
          body: `
基本メニューの「${this.$t('topTitle')}」の中の「${this.$t('topTitle')}一覧」をクリックすると、「${this.$t('topTitle')}一覧」画面が表示されます。<br><br>

変更したい${this.$t('okrDetailType')}（${this.$t('keyResultDetailType')}）をクリックすると、画面右側にクリックした${this.$t('okrDetailType')}（${this.$t('keyResultDetailType')}）が表示されます。<br><br>

進捗率を変更するには以下の2通りがあります。
<ul class="list-adjusted">
<li>・円形ゲージ内の数字をクリックし、進捗率を入力する</li>
<li>・円形ゲージの縁をクリックし、進捗率を変更（スライドにて微調整が出来ます）</li>
</ul>

「確認 進捗率を更新してよろしいですか？」ウィンドウが表示されるので、「OK」をクリックすると、進捗率が変更されます。
`
        },
        {
          head: `${this.$t('topTitle')}を完了する、完了した${this.$t('topTitle')}を確認する`,
          body: `
基本メニューの「${this.$t('topTitle')}」の中の「${this.$t('topTitle')}一覧」をクリックすると、「${this.$t('topTitle')}一覧」画面が表示されます。<br><br>

完了したい${this.$t('okrDetailType')}（${this.$t('keyResultDetailType')}）の（「期限：yyyy/mm/dd」の右側にある）「・・・」をクリックし、表示された項目の中から「完了にする」をクリックします。<br><br>

「確認 ステータスを完了に変更しますか？」ウィンドウが表示されるので、「OK」をクリックすると、「ご案内 ステータスを完了にしました。」ウィンドウが表示されるので、「OK」をクリックすると、${this.$t('topTitle')}が完了されます。<br><br>

完了した${this.$t('topTitle')}を確認するには、左側メニューの「${this.$t('topTitle')}」の中の「完了${this.$t('topTitle')}一覧」をクリックすると、「完了${this.$t('topTitle')}」画面が表示されます。<br><br>

表示される完了${this.$t('topTitle')}の一覧にて完了した${this.$t('topTitle')}を確認できます。<br>
`
        },
        {
          head: `${this.$t('topTitle')}の一覧に表示されている${this.$t('okrDetailType')}の並び順を変更する`,
          body: `
基本メニューの「${this.$t('topTitle')}」の中の「${this.$t('topTitle')}一覧」をクリックすると、「${this.$t('topTitle')}一覧」画面が表示されます。<br><br>

「${this.$t('topTitle')}一覧」画面の右上にある「表示順選択」ボタンをクリックしてリストを表示させ、${this.$t('okrDetailType')}を並び替えます。
並び替えは、次のいずれかの項目をクリックすることで実施できます。
<ul class="list-adjusted">
<li>・登録日時（降順）</li>
<li>・登録日時（昇順）</li>
<li>・更新日時（降順）</li>
<li>・更新日時（昇順）</li>
</ul>`
        },
        {
          head: `${this.$t('oneOnTitleType')}の振り返りを確認する`,
          body: `
基本メニューの「${this.$t('oneOnTitleType')}」の中の「振り返り登録」をクリックすると、「${this.$t('oneOnTitleType')}」画面に、実施した${this.$t('oneOnTitleType')}の一覧が最新にものから順に表示されます。<br><br>

${this.$t('oneOnTitleType')}の一覧より、詳細を確認したい${this.$t('oneOnTitleType')}を選択し、次の項目をクリックすることで、詳細を確認できます。
<ul class="list-adjusted">
<li>・${this.$t('firstContent1on1')}</li>
<li>・${this.$t('secondContent1on1')}</li>
<li>・${this.$t('thirdContent1on1')}</li>
<li>・${this.$t('memoContent1on1')}  ※公開設定に関わらず非公開です。</li>
</ul>`
        },
        {
          head: `${this.$t('oneOnTitleType')}の振り返りを登録する`,
          body: `
基本メニューの「${this.$t('oneOnTitleType')}」の中の「振り返り登録」をクリックすると、「${this.$t('oneOnTitleType')}登録」画面が表示され、${this.$t('oneOnTitleType')}の振り返りを登録することができます。<br><br>

「日付」は、クリックすると「カレンダー」から設定することが可能です。特に指定がない場合は、「操作日」となります。<br><br>

「相手」は、入力欄や右にある「＋」クリックするとユーザを選択することができ、1on1の相手を設定できます。 <br><br>

「公開」は、右にある「＋追加」ボタンをクリックして設定することも可能です。特に指定がない場合は、公開範囲は「全員」となります。<br><br>

振り返り内容は、次の項目の各欄に、文字入力によって登録します。<br>
<ul class="list-adjusted">
<li>・${this.$t('firstContent1on1')}</li>
<li>・${this.$t('secondContent1on1')}</li>
<li>・${this.$t('thirdContent1on1')}</li>
<li>・${this.$t('memoContent1on1')}   ※公開設定に関わらず非公開です。</li>
</ul>

画面下の「保存」または「下書きとして保存」をクリックすることで、登録または下書き保存が完了します。<br>
`
        },
        {
          head: `${this.$t('oneOnTitleType')}リクエストを送信する`,
          body: `
基本メニューの「${this.$t('oneOnTitleType')}」の中の「リクエストを送信」をクリックすると、「${this.$t('oneOnTitleType')} Request」画面が表示されます。<br><br>

「送信先」は、右にある「＋」をクリックして設定します。<br><br>

「コメント」欄に、${this.$t('oneOnTitleType')} Requestの内容を文字入力によって登録します。<br><br>

画面下の「送信」をクリックすると、送信先に${this.$t('rtfbType')}が送信されます。<br><br>

左側メニューの「リクエスト送信履歴」をクリックすると、 「${this.$t('oneOnTitleType')} Request送信履歴」を閲覧することができます。<br>
`
        },
        {
          head: `${this.$t('rtfbType')}をみる`,
          body: `
基本メニューにある「${this.$t('rtfbType')}」の中の「${this.$t('rtfbType')} 一覧」をクリックすると、${this.$t('rtfbType')}の一覧が表示されます。<br>
見たい内容を選択すると該当ページ（${this.$t('rtfbType')} 詳細）に進みます。右側の「もっと見る」をクリックすると、その人が書いた内容を全て見ることができます。<br>
`
        },
        {
          head: `${this.$t('rtfbType')}を投稿する`,
          body: `
基本メニューにある「${this.$t('rtfbType')}」の中の「${this.$t('rtfbType')} 登録」をクリックすると、${this.$t('rtfbType')}を登録することができます。<br>

「公開」は、右にある「＋追加」ボタンをクリックして設定することも可能です。特に指定がない場合は、公開範囲は「全員」となります。<br><br>

「内容」欄に${this.$t('rtfbType')}の内容を、文字入力によって登録します。<br><br>

画面下の、「保存」または「下書きとして保存」をクリックすることで、登録または下書き保存が完了します。<br>
`
        },
        {
          head: `コメントを投稿する`,
          body: `
コメントをしたい掲載内容、またはその左下にある吹き出しマークのいずれかをクリックすると、画面の右側に詳細画面が表示されます。コメントタブが選択されているのを確認し、画面右下にある長方形の枠にコメントを入力してから、「送信」ボタンを押します。<br>
`
        },
        {
          head: `「いいね」をつける`,
          body: `
${this.$t('rtfbType')}に対して「いいね」をつけたい場合は、掲載内容の下にあるグレーの☆マークをクリックしてください。または該当する${this.$t('rtfbType')}をクリックすると、画面の右側に詳細画面が表示されます。${this.$t('rtfbType')}の下にあるグレーの☆マークをクリックしてください。☆が黄色になれば「いいね」されています。<br><br>

${this.$t('topTitle')}、${this.$t('oneOnTitleType')}、${this.$t('rtfbType')}のコメントに対して「いいね」を行う場合は、「いいね」をしたいコメントの下にあるグレーの☆マークをクリックしてください。☆が黄色になれば「いいね」されています。<br>
`
        },
        {
          head: `通知をみる`,
          body: `
画面右上にベルのマークがあります。ベルのマークの横に数字があれば未読のお知らせがあります。<br><br>

通知の詳細をみるには、ベルマークをクリックして、「全て表示」を選択してください。画面上に、通知の一覧が表示されるので、見たい通知をクリックすると該当ページに進みます。<br>
`
        },
        {
          head: `他ユーザーの通知を受け取れるようにする`,
          body: `
基本メニューにある「Notice」を選択、その後「通知設定」を選択すると、「通知設定」画面が表示されます。<br>
画面中央にある「+追加」ボタンを選択し、追加したいユーザーを選択します。（複数選択可）<br>
画面中央に追加するユーザーが表示されますので、OKの場合は、「保存」ボタンを選択すると、通知の受け取りが可能になります。<br>
`
        },
        {
          head: `他ユーザーのアクションに応じた通知を受け取るように設定する`,
          body: `基本メニューにある「Notice」を選択、その後、「通知設定」を選択して画面右上の「個別設定」を押すと、
          アクション（作成、更新、削除など）の一覧が表示されます。アクションの右側にあるON-OFFボタンを選択して、通知を設定し、
          「保存」ボタンを選択すると、アクション別の通知の受け取りが可能になります。`
        },
        {
          head: `${this.$t('oneOnTitleType')}リクエストの受信を確認する`,
          body: `
基本メニューにある「Notice」を選択、その後「リクエスト受信履歴」を選択すると、リクエスト受講履歴が表示されますので、見たいメッセージを選択し、詳細（送信元とコメント）を確認します。<br>
`
        },
        {
          head: `プロフィールを編集する`,
          body: `
画面左上の写真または氏名を選択、<br>
画面中央に表示されている「編集」を選択します。<br>
編集したい項目を選択し入力します。（※メールアドレスは変更不可）<br>
入力が完了したら、「保存」ボタンを選択し終了します。<br>
`
        },
        {
          head: `コンディションを変更する`,
          body: `
画面左上のプロフィールで、お天気マークをクリックすることにより変更されます。<br>
`
        },
        {
          head: `ログアウトする`,
          body: `
右上のログアウトボタンを押します。<br>
`
        },
        {
          head: `${this.$t('topTitle')}レポートを確認する`,
          body: `
基本メニューのReport>${this.$t('topTitle')}レポートをクリックすると確認できます。${this.$t('topTitle')}または関連する${this.$t('topTitle')}を確認したいユーザーを検索して、選択します。そのユーザーの${this.$t('topTitle')}が表示され、クリックすると関連する${this.$t('topTitle')}も表示されます。開始日や期限の指定表示もできます。
`
        },
        {
          head: `${this.$t('oneOnTitleType')}レポートを確認する`,
          body: `
基本メニューのReport>${this.$t('oneOnTitleType')}レポートをクリックすると確認できます。${this.$t('oneOnTitleType')}振り返りと、振り返り時の${this.$t('topTitle')}を確認したいユーザーを検索して、選択します。そのユーザーの${this.$t('oneOnTitleType')}振り返りが表示されます。クリックすると、その日付に有効な${this.$t('topTitle')}が表示されます。振り返り日付の指定表示もできます。
`
        }
      ]
      // content1on1: content1on1,
      // contentTitle: {
      //   0: '・' + this.$t('firstContent1on1'),
      //   1: '・' + this.$t('secondContent1on1'),
      //   2: '・' + this.$t('thirdContent1on1'),
      //   3: '・' + this.$t('forthContent1on1')
      // }
    }
  },
  computed: {
    // checkContent1on1 () {
    //   return Object.keys(content1on1.content1on1).length
    // },
    // get1on1Contents () {
    //   let oneContentArray = []
    //   console.log('this.checkContent1on1', this.checkContent1on1)
    //   for (let i = 0; i < this.checkContent1on1; i++) {
    //     console.log('count::::', i, this.contentTitle[i])
    //     oneContentArray.push(this.contentTitle[i])
    //   }
    //   console.log('oneContentArray:::::', oneContentArray)
    //   let resultContent = oneContentArray.join(',')
    //   console.log('resultContent:::::', resultContent)
    //   return resultContent
    // }
  }
}
</script>
<style scoped>
.web-hidden {
  display: none;
}
.p-1 {
  padding: 0.5rem !important;
  transition: 0.2s all;
}
.card-header .btn {
  margin-top: 0;
}
.btn-info {
  background-color: #ffffff;
  border-color: #fcfcfc;
  padding: 0.8rem 1rem;
}
.btn-info:hover,
.btn-info:focus,
.btn-info.focus {
  color: #fff;
  background-color: #39b2d5;
  box-shadow: none;
}
.mb-1,
.my-1 {
  margin-bottom: 0.5rem !important;
}
.card-body,
.card-block {
  padding: 1.5rem 1.8rem;
}
</style>



// WEBPACK FOOTER //
// src/views/_webview/WebViewHelpsJARe.vue